// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__6mlPj","info":"Panel_info__jxZHj","btns":"Panel_btns__unNGI","button":"Panel_button__BuWMH","loading":"Panel_loading__SJdOz","loader":"Panel_loader__7KpyV"};